import Vue from 'vue'
import Router from 'vue-router'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' // progress bar style
import routes from './routes'
import getPageTitle from '@/utils/getPageTitle'
import { ACCESS_TOKEN } from '@/store/mutation-types'

Vue.use(Router)
NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = [
  'index',
  'products-services',
  'solution',
  'ecological-value',
  'application-market',
  'zh-action',
  'video',
  'details',
  'newsDetail',
  'zh-information',
  'informationDetail',
  'videoDetails',
  'walkinto-zh',
  'coreValuese-zh',
  'honor-zh',
  'project-zh',
  'contact-us',
  'footer',
  'header',
  'caseDetails',
  'module1',
  'module2',
  'module3',
  'module4',
  'module5',
  '404',
  '500'
] // no redirect whitelist

export const createRouter = () =>
  new Router({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes
  })

const router = createRouter()

router.beforeEach((to, from, next) => {
  NProgress.start() // 开始页面加载进度条
  const token = Vue.ss.get(ACCESS_TOKEN) // 从某处获取token，这里假设Vue.ss是一个存储机制，比如localStorage的封装
  if (token) {
    if (to.name === 'mainBusiness') {
      next('/') // 如果目标路由是'mainBusiness'，则重定向到根路径
    } else {
      next() // 否则，继续导航
    }
  } else {
    if (whiteList.includes(to.name)) {
      document.title = getPageTitle(to.meta.title) // 动态设置标题
      next() // 如果目标路由在免登录白名单中，则继续导航
    } else {
      next({ path: '/index' }) // 否则，重定向到登录页面
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
  // 百度统计
  // eslint-disable-next-line no-use-before-define
})
export default router
